import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Parking = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 105 104"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            { props.BgColor ?  <rect x="0.25" width="104" height="104" rx="50" fill={props.BgColor} /> : null }
            <path fillRule="evenodd" clipRule="evenodd" d="M21.6504 30.3999C21.6504 25.4293 25.6798 21.3999 30.6504 21.3999H73.8504C78.8209 21.3999 82.8504 25.4293 82.8504 30.3999V73.5999C82.8504 78.5705 78.8209 82.5999 73.8504 82.5999H30.6504C25.6798 82.5999 21.6504 78.5705 21.6504 73.5999V30.3999ZM30.6504 24.9999C27.6681 24.9999 25.2504 27.4176 25.2504 30.3999V73.5999C25.2504 76.5822 27.6681 78.9999 30.6504 78.9999H73.8504C76.8327 78.9999 79.2504 76.5822 79.2504 73.5999V30.3999C79.2504 27.4176 76.8327 24.9999 73.8504 24.9999H30.6504ZM43.2504 39.3999C43.2504 38.4058 44.0563 37.5999 45.0504 37.5999H54.0504C59.021 37.5999 63.0504 41.6293 63.0504 46.5999C63.0504 51.5705 59.021 55.5999 54.0504 55.5999H46.8504V63.6999C46.8504 64.694 46.0445 65.4999 45.0504 65.4999C44.0563 65.4999 43.2504 64.694 43.2504 63.6999V39.3999ZM46.8504 41.1999V51.9999H54.0504C57.0327 51.9999 59.4504 49.5822 59.4504 46.5999C59.4504 43.6176 57.0327 41.1999 54.0504 41.1999H46.8504Z"
             fill={props.color ? props.color: "white"} />

        </SvgStyled>
    );
};

export default Parking;
